<template>
  <div class="home">
    <div v-if="!showFull">
      <carousel :perPage="1" class="carousel" style="width: 100%; height: 95vh">
        <slide class="slide" style="width: 100%; text-align: center; position:relative;">
          <div
            style="
              height: calc(100vh - 30px);
              width: 100%;
              background-image: url('./1-certificate.jpg');
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center;
            "
          ></div>
        </slide>
        <slide class="slide" style="width: 100%; text-align: center; position:relative;">
          <div
            style="
              height: calc(100vh - 30px);
              width: 100%;
              background-image: url('./2-painting.jpg');
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center;
            "
          ></div>
        </slide>
      </carousel>
    </div>
    <div
      class="fullscreen"
      :style="'background-image:url(' + fullscreenImg + ')'"
      v-if="showFull"
      @click="showFull = false"
    ></div>
  </div>
</template>

<style>
.VueCarousel-pagination {
  background: none;
  /* z-index: -1; */
  position: absolute;
  bottom: -25px;
  left: 0;
}
.fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  background-color: #000;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  z-index: 9999;
  cursor: zoom-out;
}
.nft-image {
  width: 100%;
  height: 100vh;
  background-color: #f00;
  background-position: center;
  background-repeat: no-repeat;
}
.nft-image img {
  display: block;
}

.nft-image {
  height: auto;
  background-image: none !important;
}
@media screen and (min-width: 768px) {
  .slide {
    height: 100vh !important;
  }
  .carousel {
    height: 90vh !important;
  }
}
.home {
  font-family: monospace;
  font-size: 22px;
}
</style>
<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "Home",
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      showFull: false,
      fullscreenImg: "",
    };
  },
  methods: {
    initFullscreen(img) {
      const app = this;
      app.fullscreenImg = img;
      app.showFull = true;
    },
  },
};
</script>
